/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo, useMemo, useEffect } from 'react';
import CustomTable from 'components/cmn/CustomTable';
import { useProject } from 'hooks/useProject';
import { ProjectTableHead } from 'components/cmn/CustomTableHeadWrapper';
import ProjectListBody from './ProjectListBody';

function ProjectListTable(): JSX.Element {
  const { getProjectList, changePageAndSize, projectListSearchCondition, projectListSubSearchCondition } = useProject();
  const { data, isLoading, duration } = getProjectList();
  const { page, size } = projectListSearchCondition;
  const { order, orderBy } = projectListSubSearchCondition;

  const projectList = useMemo(() => {
    return data?.contents || [];
  }, [data?.contents]);

  const totalCount = useMemo(() => {
    return data?.totalCount ?? 0;
  }, [data?.totalCount]);

  const handleChangePage = (event: unknown, newPage: number): any => {
    changePageAndSize(newPage, size);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const _rowsPerPage = parseInt(event.target.value, 10);
    changePageAndSize(0, _rowsPerPage);
  };

  useEffect(() => {
    if (page !== 0 && totalCount !== 0 && projectList.length === 0) {
      changePageAndSize(page - 1, size);
    }
  }, [changePageAndSize, page, projectList.length, size, totalCount]);

  return (
    <CustomTable
      count={totalCount}
      rowsPerPage={size}
      page={page}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      isLoading={isLoading}
      maxHeight="calc(100vh - 550px)"
      duration={duration}
    >
      <ProjectTableHead order={order} orderBy={orderBy} />
      <ProjectListBody loading={isLoading} rows={projectList} duration={duration} />
    </CustomTable>
  );
}

export default memo(ProjectListTable);
